import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=2ff9e334&scoped=true"
import script from "./Part2.vue?vue&type=script&lang=js"
export * from "./Part2.vue?vue&type=script&lang=js"
import style0 from "./Part2.vue?vue&type=style&index=0&id=2ff9e334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9e334",
  null
  
)

export default component.exports